// extracted by mini-css-extract-plugin
export default {"top":"_4841ed46","middle":"_879020","bottom":"_b59dc822","shimmer":"_b9accce8","fadeIn":"_a90cab0c","divider":"_6887cf8c"};